import React, { useCallback } from 'react';
import { useNavigate } from '@core/js/hooks/navigate';
import { clsb, clsx } from '@core/js/utils/classNames.util';

import * as Types from './types';
import * as constants from '@core/js/components/common/Button/components/Button/constants';

import style from '@core/js/components/common/Button/components/Button/Button.scss';

export const Button: React.FC<Types.IButtonProps> = ({
    href,
    onClick,
    children,
    className,
    classNamesProps, /* TotalCasino changes */
    type = 'button',
    size = constants.SIZES.medium,
    view = constants.VIEWS.primary,
    color = constants.COLORS.success,
    ...props
}) => {
    const navigate = useNavigate();
    const { VIEWS, COLORS, SIZES } = constants;

    /* TotalCasino changes */
    const classNames = clsx([
        className,
        style.button,
        clsb([style, classNamesProps], [SIZES[size]]),
        clsb([style, classNamesProps], [VIEWS[view]]),
        clsb([style, classNamesProps], [COLORS[color]])
    ]);
    /* TotalCasino changes */

    const onButtonClick = useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        onClick && onClick(event);

        href && navigate(href);
    }, [href, navigate, onClick]);

    return (
        <button
            type={type}
            className={classNames}
            onClick={onButtonClick}
            {...props}
        >
            {children}
        </button>
    );
};
